import React from 'react';
import {Button, Icon, Table, Form, Header, Segment, Popup, Loader, Grid} from 'semantic-ui-react';
import axios from 'axios';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';
import { fetchAcademicYears } from '../../Lookups/util';

import download from 'downloadjs';
import { extractFileNameFromHeaders } from '../../DegreeDocumentPrint/util/util';

import { IconHeader, FiltersOnStyle } from '../../Professor/ProfessorInputGrades/css';
import Filters from './Filters';
import { Link } from 'react-router-dom';
import { ExportReactCSV } from '../../util/ExportCSV';
import SearchTableData from '../../util/SearchTableData';
import PaginationFront from '../../util/PaginationFront';
import ReactExport from 'react-data-export';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const obj = {};
const fetchStudyPrograms = () => axios.post('study-programs/filter', { ...obj });

const NoDataMessage = () => <p>Nema studenata.</p>;
const NoFilterDataMessage = () => <p>Filtriranje je uključeno! Nema studenata.</p>;

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;

export default class WithdrawalForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            filterData: [],
            academicYears: [],
            academicYearsClear: [],
            academicYear: '',
            studyPrograms: [],
            studyProgram: '',

            showFiltersOnButton: false,
            showFilterMode: false,
            loading: false,

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],

            results: [],
            excelData: []

        };
        this.getStudents = this.getStudents.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);

        this.filtersOff = this.filtersOff.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.getFilterData = this.getFilterData.bind(this);
        this.activateFilter = this.activateFilter.bind(this);
        this.getWithdrawalForm = this.getWithdrawalForm.bind(this);
        this.getResults = this.getResults.bind(this);
    }

    componentDidMount() {
        axios.all([fetchAcademicYears(), fetchStudyPrograms()])
            .then(axios.spread((academicYearsRes, sProgramsRes) => {
                const academicYears = academicYearsRes.data.reverse().map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                const studyPrograms = sProgramsRes.data.map(el => ({
                    value: el.id,
                    key: el.id,
                    text: el.studyProgramBasicName ? el.studyProgramBasicName + ' - ' + el.name : el.name
                }));
                this.setState({
                    academicYears, studyPrograms, academicYearsClear: academicYearsRes.data, studyProgram: ''
                });
                axios.get('/academic-years/current')
                    .then(res => {
                        this.setState({ academicYear: res.data.id }, () => { this.getStudents(); });
                    });
            }))
            .catch(err => {
                console.log('Failed to fetch academic years or study programs');
            });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value || null
        }, () => this.getStudents());

        if (name === 'academicYear') { this.setState({ studyProgram: '' }); }
    }


    getStudents() {
        this.setState({ loading: true });
        let obj = {};
        axios.post(`students/filter/dropped-out/${this.state.academicYear ? this.state.academicYear : -1}`, { ...obj })
            .then(res => {
                const dataa = res.data.map(el => ({
                    ...el,
                    department: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName : ''
                }));
                this.setState({ data: dataa, loading: false });
                const excelData = res.data.map(el => ([
                    { value: el.lastName},
                    { value: el.firstName},
                    { value: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName: ''},
                    { value: el.studyProgramBasicName},
                    { value: el.studyProgramName},
                    { value: el.dateEnrolled ? moment(el.dateEnrolled).format('D. M. YYYY.') : ''},
                    { value: el.dateOfAbandonment ? moment(el.dateOfAbandonment).format('D. M. YYYY.') : ''},
                ]));
                this.setState({excelData: excelData});
            })
            .catch(err => {
                console.log('Failed to fetch students');
            });
    }

    getDataToRender() {
        if (this.state.showFiltersOnButton && this.state.results.length === 0) {
            return this.state.filterData;
        }

        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.data;
    }

    getFilterData(firstName, lastName, studyProgramId) {
        this.setState({ loading: true });
        let docFilter = {};

        if (firstName) docFilter = { ...docFilter, firstName };
        if (lastName) docFilter = { ...docFilter, lastName };
        if (studyProgramId) docFilter = { ...docFilter, studyProgramId };

        axios.post(`students/filter/dropped-out/${this.state.academicYear}`, { ...docFilter })
            .then(res => {
                const filterData = res.data;
                this.setState({ filterData, showFiltersOnButton: true, loading: false, showFilterMode: false });
                const excelData = res.data.map(el => ([
                    { value: el.lastName},
                    { value: el.firstName},
                    { value: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName: ''},
                    { value: el.studyProgramBasicName},
                    { value: el.studyProgramName},
                    { value: el.dateEnrolled ? moment(el.dateEnrolled).format('D. M. YYYY.') : ''},
                    { value: el.dateOfAbandonment ? moment(el.dateOfAbandonment).format('D. M. YYYY.') : ''},
                ]));
                this.setState({excelData: excelData});
            })
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch filter results');
                toast('Došlo je do greške! Filtriranje nije uspjelo.');
            });
    }

    filtersOff() {
        const excelData = this.state.data.map(el => ([
            { value: el.lastName},
            { value: el.firstName},
            { value: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName: ''},
            { value: el.studyProgramBasicName},
            { value: el.studyProgramName},
            { value: el.dateEnrolled ? moment(el.dateEnrolled).format('D. M. YYYY.') : ''},
            { value: el.dateOfAbandonment ? moment(el.dateOfAbandonment).format('D. M. YYYY.') : ''},
        ]));
        this.setState({excelData: excelData});
        this.setState({
            showFilterMode: false, showFiltersOnButton: false, loading: false
        });
        return this.state.data;
    }
    activateFilter() {
        this.setState({ showFilterMode: !this.state.showFilterMode });
    }

    getWithdrawalForm(studentStudyProgramId, language) {
        let issueDate = moment(new Date()).format();
        let obj = {
            studentStudyProgramId, issueDate, language: language === 2 ? 'en' : window.$locale, withLogo: false
        };
        axios({
            method: 'post',
            url: '/documents/withdrawal-form',
            responseType: 'blob',
            data: { ...obj }
        })
            .then(res => {
                if (res.data.size === 0) {
                    toast('Došlo je do greške! Zahtjev nije obrađen zbog nedostatka podataka.');
                    return;
                }
                const fileName = extractFileNameFromHeaders(res.headers);
                download(res.data, fileName);
                return res;
            })
            .catch(err => {
                toast('Došlo je do greške! Zahtjev nije obrađen.');
            });
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })

    getResults(results) {
        this.setState({ results });
        this.handlePaginationChange({}, {activePage: 1})
    }


    render() {
        const headersForExport = [
            { label: 'Prezime', key: 'lastName' },
            { label: 'Ime', key: 'firstName' },
            { label: 'Odsjek', key: 'departmentsSPOU[0].organizationalUnitName' },
            { label: 'Studijski program', key: 'studyProgramBasicName' },
            { label: 'Plan i program', key: 'studyProgramName' },
        ];

        const multiDataSet = [
            {
                columns: [
                    { title: 'Prezime', width: { wpx: 150 } },
                    { title: 'Ime', width: { wpx: 150 } },
                    { title: 'Odsjek', width: { wpx: 200 } },
                    { title: 'Studijski program', width: { wpx: 200 } },
                    { title: 'Plan i program', width: { wpx: 300 } },
                    { title: 'Datum upisa', width: { wpx: 200 } },
                    { title: 'Datum ispisa', width: { wpx: 200 } },
                ],
                data: this.state.excelData,
            }
        ];

        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);

        return (
            <div>
                <Header as="h1">Štampanje ispisnica</Header>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3"> Spisak studenata
                            <Header style={IconHeader} floated="right" >
                                {this.state.showFiltersOnButton && <Button
                                    onClick={this.filtersOff}
                                    floated="left"
                                    icon
                                    labelPosition="right"
                                    color="orange"
                                    size="small"
                                    style={FiltersOnStyle}
                                ><Icon className="remove" onClick={this.filtersOff} />
                                    Filtriranje uključeno!
                                </Button>}
                                {this.getDataToRender().length ? <Popup
                                    trigger={<Icon
                                        link
                                        circular
                                        basic
                                        floated="right"
                                        name="filter"
                                        onClick={() => { this.setState({ showFilterMode: !this.state.showFilterMode }); }}
                                    />}
                                    content="Filtriraj podatke"
                                    hideOnScroll
                                    position="top center"
                                />
                                    : null}
                            </Header>
                        </Header>
                    </Segment>
                    <Segment>

                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>Akademska godina</label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder="Odaberite akademsku godinu"
                                        value={this.state.academicYear}
                                        onChange={this.handleInputChange}
                                        name="academicYear"
                                        options={this.state.academicYears}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>
                                <Form.Field />
                                <Form.Field />
                            </Form.Group>
                        </Form>

                        {this.state.showFilterMode && <Segment secondary clearing>
                            <Filters
                                onFilterData={this.getFilterData}
                                studyPrograms={this.state.studyPrograms}
                                filtersOff={this.filtersOff}
                                noIndex
                                sp
                            />
                        </Segment>
                        }

                        {this.state.loading && <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /><br /></div>}
                        {currentPosts.length  && !this.state.loading ?
                            <Table celled selectable compact>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan={17} >
                                            <Grid columns={2} stackable>

                                                <Grid.Column width={14}>
                                                    <SearchTableData profMozilla data={this.state.showFiltersOnButton ? this.state.filterData : this.state.data} getResults={this.getResults} filterItem={['firstName', 'lastName', 'studyProgramName', 'studyProgramBasicName', 'department']} />
                                                </Grid.Column>
                                                <Grid.Column width={2} textAlign={'center'}>
                                                    <ExcelFile filename="Spisak ispisanih studenata" element={<Popup
                                                        trigger={<Button animated="vertical" color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                                            <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                            <Button.Content visible>
                                                                Excel
                                                            </Button.Content>
                                                        </Button>}
                                                        content="Preuzmi spisak u Excel-u"
                                                        hideOnScroll
                                                        position="top center"
                                                    />}>
                                                        <ExcelSheet dataSet={multiDataSet} name="Studenti" />
                                                    </ExcelFile>
                                                </Grid.Column>
                                            </Grid>
                                        </Table.HeaderCell>
                                        {/*<Table.HeaderCell colSpan={16} >*/}
                                        {/*<span> {this.state.data && <ExportReactCSV color="green" csvData={this.state.data} headers={headersForExport} floated="right" fileName="Spisak ispisanih studenata" />}*/}
                                        {/*    <SearchTableData data={this.state.showFiltersOnButton ? this.state.filterData : this.state.data} getResults={this.getResults} filterItem={['firstName', 'lastName', 'studyProgramName', 'studyProgramBasicName', 'department']} />*/}
                                        {/*</span>*/}
                                        {/*</Table.HeaderCell>*/}
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.HeaderCell width={1} >R. br.</Table.HeaderCell>
                                        <Table.HeaderCell colSpan={4}>Prezime i ime studenta/ice</Table.HeaderCell>
                                        <Table.HeaderCell colSpan={3}>Odsjek</Table.HeaderCell>
                                        <Table.HeaderCell colSpan={3}>Studijski program</Table.HeaderCell>
                                        <Table.HeaderCell colSpan={2}>Datum upisa</Table.HeaderCell>
                                        <Table.HeaderCell colSpan={2}>Datum ispisa</Table.HeaderCell>
                                        <Table.HeaderCell colSpan={2}>
                                        </Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body> {currentPosts.map((el, index) =>
                                    (<Table.Row key={index}>
                                        <Table.Cell verticalAlign="middle" >
                                            {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}.
                                            </Table.Cell>
                                        <Table.Cell verticalAlign="middle" colSpan={4}>
                                            {el.lastName} {el.firstName}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" colSpan={3}>
                                            {el.departmentsSPOU.map(e => <div>{e.organizationalUnitName}</div>)}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" colSpan={3}>
                                            <strong>{el.studyProgramBasicName}</strong> | {el.studyProgramName}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" colSpan={2}>
                                            {el.dateEnrolled ? moment(el.dateEnrolled).format('D. M. YYYY.') : ''}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" colSpan={2}>
                                            {el.dateOfAbandonment ? moment(el.dateOfAbandonment).format('D. M. YYYY.') : ''}
                                        </Table.Cell >
                                        <Table.Cell textAlign="center" verticalAlign="middle" colSpan={2}>
                                            <Popup
                                                content="Ispisnica na B/H/S jeziku"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        basic="true"
                                                        circular
                                                        icon="copy outline"
                                                        size="medium"
                                                        color="blue"
                                                        onClick={() => this.getWithdrawalForm(el.id, 1)}
                                                    />}
                                            />

                                            <Popup
                                                content="Ispisnica na engleskom jeziku"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        basic="true"
                                                        circular
                                                        icon="copy outline"
                                                        size="medium"
                                                        color="teal"
                                                        onClick={() => this.getWithdrawalForm(el.id, 2)}
                                                    />}
                                            />

                                        </Table.Cell>
                                    </Table.Row>))}
                                </Table.Body>
                            </Table>
                            : (this.state.showFiltersOnButton && !this.state.loading) ?
                                <NoFilterDataMessage />
                                : !this.state.loading ? <NoDataMessage /> : ''
                        }

                        {currentPosts.length >0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}
                        <ToastContainer hideProgressBar />
                    </Segment>
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/FilterStudents/WithdrawalForm.js